// extracted by mini-css-extract-plugin
export default {"parent":"layout_parent__f7ePU","main":"layout_main__DoKCT","content":"layout_content__-05v8","contentSideOff":"layout_contentSideOff__MvemN","rightSide":"layout_rightSide__gb2yB"};